import React from 'react';
import { Link } from 'react-router-dom';
import SiteHeader from '../components/SiteHeader';
import './NotFoundPage.css';

const NotFoundPage: React.FC = () => {
  return (
    <>
      <SiteHeader />
      <div className="notfound-page">
        <div className="notfound-content">
          <p className="mono-label">Fehler 404</p>
          <h1>
            Hier ist nichts
            <br />
            außer Tiefschnee.
          </h1>
          <p className="notfound-sub">
            Die Seite, die du suchst, gibt es nicht — oder sie ist umgezogen.
          </p>
          <Link to="/" className="btn btn-primary">
            Zur Startseite
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
